import type { Nullable } from '../../types'
import { isDefined } from '../guards'

export function capitalize(value: string) {
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`
}

export function tryRemovePrefix(value: string, prefix: string) {
  if (value.startsWith(prefix)) {
    return value.substring(prefix.length)
  }

  return value
}
export function tryRemoveSuffix(value: string, suffix: string) {
  if (value.endsWith(suffix)) {
    return value.substring(0, value.length - suffix.length)
  }

  return value
}

export const isValidName = (name: Nullable<string> | undefined): name is string =>
  isDefined(name) && name.trim().length !== 0
